module.exports = __webpack_public_path__ + "img/w3_circle_left_dark.90b34d84.png";